import { render, staticRenderFns } from "./ObservacionCasoListView.vue?vue&type=template&id=5f6390ac"
import script from "./ObservacionCasoListView.vue?vue&type=script&lang=js"
export * from "./ObservacionCasoListView.vue?vue&type=script&lang=js"
import style0 from "./ObservacionCasoListView.vue?vue&type=style&index=0&id=5f6390ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports